/**
 * 「天面の最高 z × 範囲ジオメトリの XY AABB」の水平矩形 (2 三角形、上向き CCW) を作る。
 * 巻き出し・転圧の水平レイヤモードで、選択面の代わりに基準面として使う。
 * 余裕は付けない: 計算バイナリは法面 bbox ±0.2 m に壁を立てて基準面を壁まで延ばすので、
 * 基準面が壁の外に出ると失敗する。鉛直スカートは XY bbox を変えないので範囲 AABB は必ず壁の内側。
 * @param top z の基準になる頂点集合 (選択面)
 * @param extent XY 範囲の基準になる頂点集合 (対象ジオメトリ全体)
 * @returns 頂点・面が無い場合は null
 */
export function buildHorizontalPlaneGeometry(top, extent) {
    if (top.vertices.length < 3 || extent.vertices.length < 3)
        return null;
    let z = Number.NEGATIVE_INFINITY;
    for (let i = 2; i < top.vertices.length; i += 3) {
        z = Math.max(z, top.vertices[i]);
    }
    let minX = Number.POSITIVE_INFINITY;
    let minY = Number.POSITIVE_INFINITY;
    let maxX = Number.NEGATIVE_INFINITY;
    let maxY = Number.NEGATIVE_INFINITY;
    for (let i = 0; i + 1 < extent.vertices.length; i += 3) {
        minX = Math.min(minX, extent.vertices[i]);
        maxX = Math.max(maxX, extent.vertices[i]);
        minY = Math.min(minY, extent.vertices[i + 1]);
        maxY = Math.max(maxY, extent.vertices[i + 1]);
    }
    return {
        vertices: [minX, minY, z, maxX, minY, z, maxX, maxY, z, minX, maxY, z],
        indices: [0, 1, 2, 0, 2, 3],
    };
}
//# sourceMappingURL=horizontal-base-plane.js.map